function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 3.489c0-.27.202-.489.45-.489h11.1c.248 0 .45.219.45.489s-.202.488-.45.488H2.45c-.248 0-.45-.218-.45-.488zM2 8c0-.27.202-.489.45-.489h11.1c.248 0 .45.22.45.489 0 .27-.202.489-.45.489H2.45C2.203 8.489 2 8.269 2 8zm0 4.511c0-.27.202-.488.45-.488h11.1c.248 0 .45.218.45.488s-.202.489-.45.489H2.45c-.248 0-.45-.219-.45-.489z",
  fill: "#2D2D2D"
});
function SvgMen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Menú.svg";
export { SvgMen as ReactComponent };